import { useSyncExternalStore } from 'react'

/**
 * Tiny external store that lets the lesson screen tell the tab navigator to hide
 * the bottom tab bar while the player is in immersive focus mode. We can't use
 * `navigation.setOptions({ tabBarStyle })` because the tab bar is rendered via a
 * custom `tabBar` prop that ignores per-screen options.
 */
let focused = false
const listeners = new Set<() => void>()

export function setPlayerFocusActive(value: boolean) {
  if (focused === value) return
  focused = value
  listeners.forEach((l) => l())
}

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

function getSnapshot() {
  return focused
}

export function usePlayerFocusActive() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
}
